import { AmountValidation } from "utils/validators/AmountValidation";
import { LenderMonthlyInterestValidation } from "utils/validators/LenderMonthlyInterestValidation";
import { SetupFeeValidation } from "utils/validators/SetupFeeValidation";
import * as yup from "yup";

import type { Currency } from "@krea/shared/types/common";

import { BidTypeEnum } from "@/features/common/enums";
import type { IRevolvingCreditBidInput } from "@/features/lender-responses/types/lender-response";

export const revolvingCreditBidSchema: (
  currency: Currency,
  formatWithCurrency: (value: number) => string,
) => yup.ObjectSchema<IRevolvingCreditBidInput> = (
  currency,
  formatWithCurrency,
) =>
  yup.object().shape({
    type: yup
      .string()
      .required("Type is required")
      .oneOf([BidTypeEnum.REVOLVING_CREDIT])
      .default(BidTypeEnum.REVOLVING_CREDIT),
    amount: AmountValidation(currency, formatWithCurrency),
    monthlyAmortisation: yup
      .number()
      .required("Monthly amortisation is required")
      .min(
        0,
        (schema) => `Monthly amortisation can't be lower than ${schema.min}%`,
      )
      .max(
        100,
        (schema) => `Monthly amortisation can't be greater than ${schema.max}%`,
      ),
    lenderMonthlyInterest: LenderMonthlyInterestValidation({
      isFunction: () => true,
    }).required(),
    withdrawalFee: yup
      .number()
      .required("Withdrawal Fee is required")
      .min(0, (schema) => `Withdrawal Fee can't be lower than ${schema.min}%`)
      .max(
        100,
        (schema) => `Withdrawal Fee can't be greater than ${schema.max}%`,
      ),
    setupFee: SetupFeeValidation(formatWithCurrency),
    limitFeePerYear: yup.number().optional().nullable(),
    postalFee: yup.number().optional().nullable(),
  });

export const revolvingCreditBidDefaultValues: IRevolvingCreditBidInput = {
  type: BidTypeEnum.REVOLVING_CREDIT,
  amount: undefined,
  monthlyAmortisation: undefined,
  lenderMonthlyInterest: undefined,
  withdrawalFee: undefined,
  setupFee: undefined,
  limitFeePerYear: undefined,
  postalFee: undefined,
};
